import _IconMenuFold from "@arco-design/web-react/icon/react-icon/IconMenuFold";
import _IconMenuUnfold from "@arco-design/web-react/icon/react-icon/IconMenuUnfold";
import "@arco-design/web-react/es/Spin/style";
import _Spin from "@arco-design/web-react/es/Spin";
import _IconExclamationCircle from "@arco-design/web-react/icon/react-icon/IconExclamationCircle";
import _IconCheckCircle from "@arco-design/web-react/icon/react-icon/IconCheckCircle";
import _IconQuestionCircle from "@arco-design/web-react/icon/react-icon/IconQuestionCircle";
import _IconHome from "@arco-design/web-react/icon/react-icon/IconHome";
import _IconStamp from "@arco-design/web-react/icon/react-icon/IconStamp";
import _IconTool from "@arco-design/web-react/icon/react-icon/IconTool";
import _IconStorage from "@arco-design/web-react/icon/react-icon/IconStorage";
import _IconCalendarClock from "@arco-design/web-react/icon/react-icon/IconCalendarClock";
import _IconSelectAll from "@arco-design/web-react/icon/react-icon/IconSelectAll";
import _IconFile from "@arco-design/web-react/icon/react-icon/IconFile";
import _IconCommon from "@arco-design/web-react/icon/react-icon/IconCommon";
import _IconSubscribed from "@arco-design/web-react/icon/react-icon/IconSubscribed";
import _IconCustomerService from "@arco-design/web-react/icon/react-icon/IconCustomerService";
import _IconCode from "@arco-design/web-react/icon/react-icon/IconCode";
import "@arco-design/web-react/es/Layout/style";
import _Layout from "@arco-design/web-react/es/Layout";
import "@arco-design/web-react/es/Menu/style";
import _Menu from "@arco-design/web-react/es/Menu";
import React, { useState, useRef, useMemo, useEffect, useContext } from 'react';
import { Switch, Route, Redirect, useHistory } from 'react-router-dom';
import { AliveScope, KeepAlive, useUnactivate, useAliveController } from 'react-activation';
import { GlobalContext } from './context';
import cs from 'classnames';
import { useSelector } from 'react-redux';
import qs from 'query-string';
import NProgress from 'nprogress';
import Navbar from './components/NavBar';
import FooterSlogan from './components/FooterSlogan';
import useRoute from '@/routes';
import useLocale from './utils/useLocale';
import getUrlParams from './utils/getUrlParams';
import lazyload from './utils/lazyload';
import HelpCenter from './pages/help';
import styles from './style/layout.module.less';
const MenuItem = _Menu.Item;
const SubMenu = _Menu.SubMenu;
const Sider = _Layout.Sider;
const Content = _Layout.Content;
const ShowBreadcrumb = false;
function getIconFromKey(key) {
  switch (key) {
    case 'system':
      return /*#__PURE__*/React.createElement(_IconCode, {
        className: styles.icon
      });
    case 'workbench':
      return /*#__PURE__*/React.createElement(_IconCustomerService, {
        className: styles.icon
      });
    case 'sales':
      return /*#__PURE__*/React.createElement(_IconSubscribed, {
        className: styles.icon
      });
    case 'product':
      return /*#__PURE__*/React.createElement(_IconCommon, {
        className: styles.icon
      });
    case 'plan':
      return /*#__PURE__*/React.createElement(_IconFile, {
        className: styles.icon
      });
    case 'purchase':
      return /*#__PURE__*/React.createElement(_IconSelectAll, {
        className: styles.icon
      });
    case 'delivery':
      return /*#__PURE__*/React.createElement(_IconCalendarClock, {
        className: styles.icon
      });
    case 'warehouse':
      return /*#__PURE__*/React.createElement(_IconStorage, {
        className: styles.icon
      });
    case 'produce':
      return /*#__PURE__*/React.createElement(_IconTool, {
        className: styles.icon
      });
    case 'finance':
      return /*#__PURE__*/React.createElement(_IconStamp, {
        className: styles.icon
      });
    case 'corp':
      return /*#__PURE__*/React.createElement(_IconHome, {
        className: styles.icon
      });
    case 'help':
      return /*#__PURE__*/React.createElement(_IconQuestionCircle, {
        className: styles.icon
      });
    case 'result':
      return /*#__PURE__*/React.createElement(_IconCheckCircle, {
        className: styles.icon
      });
    case 'exception':
      return /*#__PURE__*/React.createElement(_IconExclamationCircle, {
        className: styles.icon
      });
    default:
      return /*#__PURE__*/React.createElement("div", {
        className: styles['icon-empty']
      });
  }
}
function KeepAlivePage({
  children
}) {
  useUnactivate(() => {
    // 安全地隐藏所有 tooltip, popover, dropdown 元素
    document.querySelectorAll('.arco-tooltip, .arco-popover, .arco-dropdown').forEach(el => {
      try {
        // 先检查元素是否还在文档中
        if (document.body.contains(el)) {
          el.style.display = 'none';
          el.style.visibility = 'hidden';
          el.style.opacity = '0';
          el.style.pointerEvents = 'none';
        }
      } catch (e) {
        // 忽略任何错误，防止页面崩溃
      }
    });

    // 清除可能遗留的 ARIA 相关属性
    try {
      document.querySelectorAll('[aria-describedby]').forEach(el => {
        el.removeAttribute('aria-describedby');
      });
    } catch (e) {
      // 忽略任何错误
    }
  });
  return children;
}
function getFlattenRoutes(routes) {
  const res = [];
  function travel(_routes) {
    _routes.forEach(route => {
      const visibleChildren = (route.children || []).filter(child => !child.ignore);
      if (route.key && (!route.children || !visibleChildren.length)) {
        try {
          // 移除路由参数部分，只保留基础路径用于导入组件
          const importPath = route.key.split(':')[0].replace(/\/$/, '');
          route.component = lazyload(() => import(`./pages/${importPath}`));
          res.push(route);
        } catch (e) {
          console.error(e);
        }
      }
      if (route.children && route.children.length) {
        travel(route.children);
      }
    });
  }
  travel(routes);
  return res;
}
function PageContent({
  lang
}) {
  const {
    clear
  } = useAliveController();
  const urlParams = getUrlParams();
  const history = useHistory();
  const pathname = history.location.pathname;
  const currentComponent = qs.parseUrl(pathname).url.slice(1);
  const locale = useLocale();
  const settings = useSelector(state => state.settings);
  const userInfo = useSelector(state => state.userInfo);
  const userLoading = useSelector(state => state.userLoading);
  const [routes, defaultRoute] = useRoute(userInfo?.permissions);
  const defaultSelectedKeys = [currentComponent || defaultRoute];
  const paths = (currentComponent || defaultRoute).split('/');
  const defaultOpenKeys = paths.slice(0, paths.length - 1);

  // const [breadcrumb, setBreadCrumb] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState(defaultSelectedKeys);
  const [openKeys, setOpenKeys] = useState(defaultOpenKeys);
  const routeMap = useRef(new Map());
  const menuMap = useRef(new Map());
  const navbarHeight = 60;
  const menuWidth = collapsed ? 48 : settings.menuWidth;
  const showNavbar = settings.navbar && urlParams.navbar !== false;
  const showMenu = settings.menu && urlParams.menu !== false;
  const showFooter = settings.footer && urlParams.footer !== false;
  const flattenRoutes = useMemo(() => getFlattenRoutes(routes) || [], [routes]);

  // function renderRoutes(locale) {
  //   routeMap.current.clear();
  //   return function travel(_routes: IRoute[], level, parentNode = []) {
  //     return _routes.map((route) => {
  //       const { breadcrumb = true, ignore } = route;
  //       const iconDom = getIconFromKey(route.key);
  //       const titleDom = (
  //         <>
  //           {iconDom} {locale[route.name] || route.name}
  //         </>
  //       );

  //       const importPath = route.key.split(':')[0].replace(/\/$/, '');
  //       routeMap.current.set(
  //         `/${importPath}`,
  //         breadcrumb ? [...parentNode, route.name] : []
  //       );

  //       const visibleChildren = (route.children || []).filter((child) => {
  //         const { ignore, breadcrumb = true } = child;
  //         if (ignore || route.ignore) {
  //           const childImportPath = child.key.split(':')[0].replace(/\/$/, '');
  //           routeMap.current.set(
  //             `/${childImportPath}`,
  //             breadcrumb ? [...parentNode, route.name, child.name] : []
  //           );
  //         }

  //         return !ignore;
  //       });

  //       if (ignore) {
  //         return '';
  //       }
  //       if (visibleChildren.length) {
  //         menuMap.current.set(route.key, { subMenu: true });
  //         return (
  //           <SubMenu key={route.key} title={titleDom}>
  //             {travel(visibleChildren, level + 1, [...parentNode, route.name])}
  //           </SubMenu>
  //         );
  //       }
  //       menuMap.current.set(route.key, { menuItem: true });
  //       return <MenuItem key={route.key}>{titleDom}</MenuItem>;
  //     });
  //   };
  // }

  // function onClickMenuItem(key) {
  //   const currentRoute = flattenRoutes.find((r) => r.key === key);
  //   const component = currentRoute.component;
  //   const preload = component.preload();
  //   NProgress.start();
  //   preload.then(() => {
  //     history.push(currentRoute.path ? currentRoute.path : `/${key}`);
  //     NProgress.done();
  //   });
  // }

  // function toggleCollapse() {
  //   setCollapsed((collapsed) => !collapsed);
  // }

  const paddingLeft = showMenu ? {
    paddingLeft: menuWidth
  } : {};
  const paddingTop = showNavbar ? {
    paddingTop: navbarHeight
  } : {};
  const paddingStyle = {
    ...paddingLeft,
    ...paddingTop
  };
  function updateMenuStatus() {
    const pathKeys = pathname.split('/');
    const newSelectedKeys = [];
    const newOpenKeys = [...openKeys];
    while (pathKeys.length > 0) {
      const currentRouteKey = pathKeys.join('/');
      const menuKey = currentRouteKey.replace(/^\//, '');
      const menuType = menuMap.current.get(menuKey);
      if (menuType && menuType.menuItem) {
        newSelectedKeys.push(menuKey);
      }
      if (menuType && menuType.subMenu && !openKeys.includes(menuKey)) {
        newOpenKeys.push(menuKey);
      }
      pathKeys.pop();
    }
    setSelectedKeys(newSelectedKeys);
    setOpenKeys(newOpenKeys);
  }
  useEffect(() => {
    let routeConfig = routeMap.current.get(pathname);
    // 如果当前路径没有配置路由，逐层剥离末尾路径段以匹配含多参数的路由（如 /delivery/fee/:biz_id?/:biz_no?/:biz_type?）
    if (!routeConfig) {
      const segments = pathname.split('/');
      while (segments.length > 1) {
        segments.pop();
        routeConfig = routeMap.current.get(segments.join('/') || '/');
        if (routeConfig) break;
      }
    }

    // setBreadCrumb(routeConfig || []);
    updateMenuStatus();
  }, [pathname]);

  // 监听语言变化，清除所有 keepAlive 缓存
  useEffect(() => {
    clear();
  }, [lang, clear]);
  return /*#__PURE__*/React.createElement(Switch, null, flattenRoutes.map((route, index) => {
    const routePath = route.path || `/${route.key}`;
    return /*#__PURE__*/React.createElement(Route, {
      key: `${index}-${lang}`,
      path: routePath,
      render: props => route.keepAlive ? /*#__PURE__*/React.createElement(KeepAlive, {
        name: `${lang}-${props.location.pathname}`,
        saveScrollPosition: "screen"
      }, /*#__PURE__*/React.createElement(KeepAlivePage, null, /*#__PURE__*/React.createElement(route.component, props))) : /*#__PURE__*/React.createElement(route.component, props)
    });
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/help"
  }, /*#__PURE__*/React.createElement(HelpCenter, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/"
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: `/${defaultRoute}`
  })), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    component: lazyload(() => import('./pages/exception/403'))
  }));
}
function PageLayout() {
  const {
    lang
  } = useContext(GlobalContext);
  const urlParams = getUrlParams();
  const history = useHistory();
  const pathname = history.location.pathname;
  const currentComponent = qs.parseUrl(pathname).url.slice(1);
  const locale = useLocale();
  const settings = useSelector(state => state.settings);
  const userInfo = useSelector(state => state.userInfo);
  const userLoading = useSelector(state => state.userLoading);
  const [routes, defaultRoute] = useRoute(userInfo?.permissions);
  const defaultSelectedKeys = [currentComponent || defaultRoute];
  const paths = (currentComponent || defaultRoute).split('/');
  const defaultOpenKeys = paths.slice(0, paths.length - 1);
  const [breadcrumb, setBreadCrumb] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState(defaultSelectedKeys);
  const [openKeys, setOpenKeys] = useState(defaultOpenKeys);
  const routeMap = useRef(new Map());
  const menuMap = useRef(new Map());
  const navbarHeight = 60;
  const menuWidth = collapsed ? 48 : settings.menuWidth;
  const showNavbar = settings.navbar && urlParams.navbar !== false;
  const showMenu = settings.menu && urlParams.menu !== false;
  const showFooter = settings.footer && urlParams.footer !== false;
  const flattenRoutes = useMemo(() => getFlattenRoutes(routes) || [], [routes]);
  function renderRoutes(locale) {
    routeMap.current.clear();
    return function travel(_routes, level, parentNode = []) {
      return _routes.map(route => {
        const {
          breadcrumb = ShowBreadcrumb,
          ignore
        } = route;
        const iconDom = getIconFromKey(route.key);
        const titleDom = /*#__PURE__*/React.createElement(React.Fragment, null, iconDom, " ", locale[route.name] || route.name);
        const importPath = route.key.split(':')[0].replace(/\/$/, '');
        routeMap.current.set(`/${importPath}`, breadcrumb ? [...parentNode, route.name] : []);
        const visibleChildren = (route.children || []).filter(child => {
          const {
            ignore,
            breadcrumb = ShowBreadcrumb
          } = child;
          if (ignore || route.ignore) {
            const childImportPath = child.key.split(':')[0].replace(/\/$/, '');
            routeMap.current.set(`/${childImportPath}`, breadcrumb ? [...parentNode, route.name, child.name] : []);
          }
          return !ignore;
        });
        if (ignore) {
          return '';
        }
        if (visibleChildren.length) {
          menuMap.current.set(route.key, {
            subMenu: true
          });
          return /*#__PURE__*/React.createElement(SubMenu, {
            key: route.key,
            title: titleDom
          }, travel(visibleChildren, level + 1, [...parentNode, route.name]));
        }
        menuMap.current.set(route.key, {
          menuItem: true
        });
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: route.key
        }, titleDom);
      });
    };
  }
  function onClickMenuItem(key) {
    const currentRoute = flattenRoutes.find(r => r.key === key);
    const component = currentRoute.component;
    const preload = component.preload();
    NProgress.start();
    preload.then(() => {
      history.push(currentRoute.path ? currentRoute.path : `/${key.split(':')[0].replace(/\/$/, '')}`);
      NProgress.done();
    });
  }
  function toggleCollapse() {
    setCollapsed(collapsed => !collapsed);
  }
  const paddingLeft = showMenu ? {
    paddingLeft: menuWidth
  } : {};
  const paddingTop = showNavbar ? {
    paddingTop: navbarHeight
  } : {};
  const paddingStyle = {
    ...paddingLeft,
    ...paddingTop
  };
  function updateMenuStatus() {
    const pathKeys = pathname.split('/');
    const newSelectedKeys = [];
    const newOpenKeys = [...openKeys];
    while (pathKeys.length > 0) {
      const currentRouteKey = pathKeys.join('/');
      const menuKey = currentRouteKey.replace(/^\//, '');
      const menuType = menuMap.current.get(menuKey);
      if (menuType && menuType.menuItem) {
        newSelectedKeys.push(menuKey);
      }
      if (menuType && menuType.subMenu && !openKeys.includes(menuKey)) {
        newOpenKeys.push(menuKey);
      }
      pathKeys.pop();
    }
    setSelectedKeys(newSelectedKeys);
    setOpenKeys(newOpenKeys);
  }
  useEffect(() => {
    let routeConfig = routeMap.current.get(pathname);
    // 如果当前路径没有配置路由，逐层剥离末尾路径段以匹配含多参数的路由（如 /delivery/fee/:biz_id?/:biz_no?/:biz_type?）
    if (!routeConfig) {
      const segments = pathname.split('/');
      while (segments.length > 1) {
        segments.pop();
        routeConfig = routeMap.current.get(segments.join('/') || '/');
        if (routeConfig) break;
      }
    }
    setBreadCrumb(routeConfig || []);
    updateMenuStatus();
  }, [pathname]);
  return /*#__PURE__*/React.createElement(_Layout, {
    className: styles.layout
  }, /*#__PURE__*/React.createElement("div", {
    className: cs(styles['layout-navbar'], {
      [styles['layout-navbar-hidden']]: !showNavbar
    })
  }, /*#__PURE__*/React.createElement(Navbar, {
    show: showNavbar
  })), userLoading && /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      background: 'var(--color-bg-1)'
    }
  }, /*#__PURE__*/React.createElement(_Spin, {
    className: styles['spin']
  })), /*#__PURE__*/React.createElement(_Layout, null, showMenu && /*#__PURE__*/React.createElement(Sider, {
    className: styles['layout-sider'],
    width: menuWidth,
    collapsed: collapsed,
    onCollapse: setCollapsed,
    trigger: null,
    collapsible: true,
    breakpoint: "xl",
    style: paddingTop
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['menu-wrapper']
  }, /*#__PURE__*/React.createElement(_Menu, {
    collapse: collapsed,
    onClickMenuItem: onClickMenuItem,
    selectedKeys: selectedKeys,
    openKeys: openKeys,
    onClickSubMenu: (_, openKeys) => setOpenKeys(openKeys)
  }, renderRoutes(locale)(routes, 1))), /*#__PURE__*/React.createElement("div", {
    className: styles['collapse-btn'],
    onClick: toggleCollapse
  }, collapsed ? /*#__PURE__*/React.createElement(_IconMenuUnfold, null) : /*#__PURE__*/React.createElement(_IconMenuFold, null))), /*#__PURE__*/React.createElement(_Layout, {
    className: styles['layout-content'],
    style: paddingStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['layout-content-wrapper']
  }, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(AliveScope, null, /*#__PURE__*/React.createElement(PageContent, {
    lang: lang
  })))), showFooter && /*#__PURE__*/React.createElement(FooterSlogan, null))));
}
export default PageLayout;